"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewProductsWidget = void 0;
const react_1 = __importDefault(require("react"));
const preview_products_widget_content_1 = require("./preview-products-widget-content");
const preview_products_widget_styles_1 = require("./preview-products-widget.styles");
const components_1 = require("../components");
const generic_1 = require("../../generic");
const icons_1 = require("../../icons");
const localization_1 = require("../../localization");
const PreviewProductsWidget = ({ showNoDataFallback, showPreviewLoader, previewLoaderComponent, showWidgetContent, catalogLoadingError, onReEnrich, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(preview_products_widget_styles_1.StyledPreviewProductsWidget, null, showNoDataFallback && react_1.default.createElement(generic_1.NoDataFallback, { className: "no-preview-products", icon: react_1.default.createElement(icons_1.TeamIllustration, null), title: t({ key: 'PREVIEW_PRODUCTS_NO_DATA_TITLE' }) }), catalogLoadingError && react_1.default.createElement(components_1.Alert, { severity: "error" }, catalogLoadingError), showPreviewLoader && previewLoaderComponent, showWidgetContent && react_1.default.createElement(preview_products_widget_content_1.PreviewProductsWidgetContent, { onReEnrich: onReEnrich })));
};
exports.PreviewProductsWidget = PreviewProductsWidget;
exports.default = exports.PreviewProductsWidget;
